import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';


class DateAndTime extends Component {
  constructor(props) {
    super(props);
    this.state = {
      day: '',
      date: '',
      time: '',
    };

    this.updateTime = this.updateTime.bind(this);
    this.getDayAsString = this.getDayAsString.bind(this);
  }

  componentDidMount() {
    this.updateTime();
  }


  getDayAsString(day) {
    switch (day) {
      case 0: return 'Sonntag';
      case 1: return 'Montag';
      case 2: return 'Dienstag';
      case 3: return 'Mittwoch';
      case 4: return 'Donnerstag';
      case 5: return 'Freitag';
      case 6: return 'Samstag';
      default: return '';
    }
  }

  updateTime() {
    const now = moment();
    const newState = {
      day: this.getDayAsString(now.day()),
      date: now.format('DD.MM.YYYY'),
      time: now.format('HH:mm'),
    };
    this.setState(newState);
    setTimeout(this.updateTime, 1000);
  }


  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <div className={classes.dateWrapper}>
          <div>{this.state.day}</div>
          <div>{this.state.date}</div>
        </div>
        <div className={classes.timeWrapper}>
          <div>{this.state.time}</div>
        </div>
      </div>
    );
  }
}

const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    'justify-content': 'flex-end',
  },
  dateWrapper: {
    padding: 5,
  },
  timeWrapper: {
    paddingLeft: 5,
    paddingRight: 10,
    fontSize: 30,
  },
};

DateAndTime.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DateAndTime);
